export default "__VITE_ASSET__DslgjFsc__"